$(document).ready(function () {
    initializeUseNewDeliveryAddress($('.delivery-address--form'));
});

function initializeUseNewDeliveryAddress($container) {
    $container.each(function () {
        var $this = $(this);
        bindAddAddressWithSavedAddresses($this, $this.find('.saved-address-wrapper.use-address'));

        var $addAddress = $('.ua--add-address', $this);
        if ($this.find('.saved-address-wrapper.use-address input:checked').length) {
            resetAddAddress($addAddress);
        }

        $('#use-new-address').on('click', function (e) {
            e.preventDefault();
            $addAddress.closest('.checkout-your-address-wrapper').find('.saved-address-wrapper.use-address input').prop('checked', false);
            $('#boxaddress').slideDown(400);
            $addAddress.addClass('expanded');

            $addAddress.find('input.use-new-address').prop('checked', 'checked');
            $(this).addClass('hide');
        });
    });
}

function bindAddAddressWithSavedAddresses($container, $containerRadioButton) {
    $containerRadioButton.find('input').on('change', function () {
            $('#use-new-address').removeClass('hide');
            resetAddAddress($container);
        });
}

function resetAddAddress($addAddress) {
    $('#boxaddress').slideUp(400, function () {
            $addAddress.find('#use-new-address').removeClass('hide');
            $(this).find('input').filter(function () {
                var $this = $(this);
                return !$this.prop('disabled') && $this.prop('type') != 'checkbox' && $this.prop('type') != 'hidden' && !$this.data("keep-value");
            }).val('');
        });

    $addAddress.find('[id^=postalCodeChangeMessage]').addClass("hide");// On reset form, hide alert message of postal code change
    $addAddress.removeClass('expanded');
}